import { ModelBase } from "./base/model.base";

export class KeyValue extends ModelBase {
    static TABLENAME = "KeyValues";
    public key: string = "";
    public value: string = "";

    constructor(key, value) {
        super(KeyValue.TABLENAME);

        this.key = key;
        this.value = value;
    }
}
